import {
    CURRENT_ENTER,
    HEADER_STATUS,
    ROLE_ID
  } from './mutation-type'

export const set_CurrentPage = ({ commit }, _head) => {
  commit(CURRENT_ENTER,_head)
}
export const set_headerStatus = ({ commit }, _head) => {
  commit(HEADER_STATUS,_head)
}
export const set_roleId = ({ commit }, _head) => {
  commit(ROLE_ID,_head)
}
